import { request } from '@/utils/request'

export const favoritesMixin = {
  data() {
    return {
      favoriteIds: new Set(),
      loadingFavorites: false
    }
  },

  methods: {
    async loadFavorites() {
      if (!localStorage.getItem('token') || this.loadingFavorites) return
      this.loadingFavorites = true

      try {
        const response = await request('/api/image/favorite/list?pageNum=1&pageSize=1000')
        if (response.ok) {
          this.favoriteIds = new Set(response.data.list.map(item => item.imageId))
        }
      } catch (error) {
        console.error('获取收藏列表失败:', error)
      } finally {
        this.loadingFavorites = false
      }
    },

    async toggleFavorite(imageId) {
      if (!localStorage.getItem('token')) {
        this.$router.push('/login')
        return
      }

      try {
        if (this.favoriteIds.has(imageId)) {
          // 取消收藏
          const response = await request(`/api/image/favorite/${imageId}`, {
            method: 'POST'
          })
          if (response.ok) {
            // 重新加载收藏列表以确保状态同步
            await this.loadFavorites()
          }
        } else {
          // 添加收藏
          const response = await request(`/api/image/favorite/${imageId}`, {
            method: 'POST'
          })
          if (response.ok) {
            // 重新加载收藏列表以确保状态同步
            await this.loadFavorites()
          }
        }
      } catch (error) {
        console.error('收藏操作失败:', error)
        alert('操作失败，请重试')
      }
    },

    isFavorited(imageId) {
      return this.favoriteIds.has(imageId)
    }
  }
}
